var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.6665 20.25V10.625M25.9165 7.875V18.875C25.9165 20.6984 25.1922 22.447 23.9029 23.7364C22.6136 25.0257 20.8649 25.75 19.0415 25.75H8.0415C6.21814 25.75 4.46946 25.0257 3.18014 23.7364C1.89083 22.447 1.1665 20.6984 1.1665 18.875V7.875C1.1665 6.05164 1.89083 4.30295 3.18014 3.01364C4.46946 1.72433 6.21814 1 8.0415 1H19.0415C20.8649 1 22.6136 1.72433 23.9029 3.01364C25.1922 4.30295 25.9165 6.05164 25.9165 7.875Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1665 20.2499V15.7812M12.1665 15.7812V10.6249M12.1665 15.7812C12.1665 10.6249 20.4165 10.6249 20.4165 15.7812V20.2499M6.6665 6.51366L6.68025 6.49854",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.38904ee70c5ff3481d9baf8b1e7610d6.svg";
export { ForwardRef as ReactComponent };